module.exports = __webpack_public_path__ + "static/media/empty-feed.3ebce7f3.png";